export const menuTitle = { title: "EMPLOYEE STATUS", label: "Employee Status" }
  